<template lang="pug">
span
  v-menu(v-model="showMenu" rounded="lg" allow-overflow attach :close-on-content-click="false" offset-y max-height="360" min-width="320" max-width="320" nudge-bottom="8")
    template(v-slot:activator="{ on, attrs }")
      v-btn.px-2.button-text-normal.button-filter.text-none(v-if="selectedStatuses.length" outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(@click.stop="clear" size=13) $yzi-x-circle
        .text-xs.font-semibold {{ title }}
        .px-1.neutral400--text | 
        .text-xs.primary--text.font-medium.capitalize {{ getSelectedStatuses() }}
        v-icon.ml-1(size=16) $yzi-chevron-down
      v-btn.px-2.button-text-normal.border-dashed.button-filter(v-else outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(size=13) $yzi-plus-circle
        .text-xs.text-none.font-semibold {{ title }}
    
    .white
      .font-semibold.text-sm.px-4.pt-4.pb-2 {{ $t('filter_by') }} {{ title.toLowerCase() }}
      div.pt-1.pb-4
        template(v-for="option in options")
          .d-flex.text-sm.py-2.px-4
            yc-checkbox(:input-value="isChecked(option.value)" @change="clickItem(option)")
            .ml-4.clickable(@click="clickItem(option)") {{ option.text }}

    .bottom-0.sticky.z-1.white
      .d-flex.align-center.px-4.py-3.border-t
        .text-sm.font-semibold.underline.normal-case.neutral700--text.cursor-pointer(v-if="selectedStatuses.length" @click="clear") {{ $t('clear') }}
        v-spacer
        v-btn.button-sm(@click="apply" color="primary" depressed :disabled="disabledButton") {{ $t('apply') }}

</template>

<script>
export default {
  props: {
    filter: {
      type: Object,
      default: (() => {})
    },
    checkInitialValue: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    showMenu: false,
    title: 'Review request status',
    options: [
      { text: 'Scheduled', value: 'scheduled' },
      { text: 'Invite sent', value: 'sent' },
      { text: 'New', value: 'new' },
    ],
    statuses: [],
    selectedStatuses: []
  }),
  computed: {
    disabledButton () {
      return this.statuses.length === 0
    }
  },
  watch: {
    filter: {
      handler () {
        if (!this.filter.key) { this.clearData() }
      } 
    },
  },
  mounted () {
    this.setData()
  },
  methods: {
    setData () {
      if (this.checkInitialValue) {
        if (this.filter.key) {
          this.selectedStatuses = this.filter.value.split(',')
          this.statuses = this.filter.value.split(',')
        }
      }
    },
    clear () {
      this.clearData()
      this.$emit('update:filter', {})
    },
    clearData () {
      this.statuses = []
      this.selectedStatuses = []
    },
    apply () {
      this.showMenu = false
      this.selectedStatuses = [...this.statuses]
      let filter = { key: 'review_invite_status', value: this.statuses.join(',') }
      this.$emit('update:filter', filter)
    },
    getSelectedStatuses () {
      const count = this.selectedStatuses.length
      if (count <= 2) {
        return this.selectedStatuses.join(', ')
      }
      return `${count} selected`
    },
    clickItem (item) {
      if (this.statuses.includes(item.value)) {
        this.statuses = this.statuses.filter(f => f !== item.value)
      } else {
        this.statuses.push(item.value)
      }
    },
    isChecked (value) {
      return this.statuses.filter(item => item === value).length > 0
    }
  }
}
</script>

<style lang="scss" scoped>
.button-filter {
  min-width: 0 !important;
  color: #848484;
}
</style>